import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RutaConProfesores } from 'components/seguimientoDesafio/seguimientoDesafio.graphql';
import { Rutas } from 'generated/graphql';

interface DisplayGuiaSeg {
	display: boolean;
	numeroSesion: number;
	rutaKey: string | null;
	rutaData: RutaConProfesores | null;
	listRuta: Rutas[] | undefined | null;
}

const initialState: DisplayGuiaSeg = {
	display: false,
	numeroSesion: 1,
	rutaKey: null,
	rutaData: null,
	listRuta: null
};

const displayDesafioCompromisoSegSlice = createSlice({
	name: 'displayDesafioCompromisoSeg',
	initialState,
	reducers: {
		setDisplayDesafioCompromisoSeg: (state, action: PayloadAction<DisplayGuiaSeg>) => {
			return action.payload;
		},
		updateTypeDisplayDesafioCompromisoSeg: (state, action) => {
			return {
				...state,
				numeroSesion: action.payload.numeroSesion
			};
		},

		updateRutaDisplayDesafioCompromisoSeg: (state, action) => {
			return {
				...state,
				rutaKey: action.payload.rutaKey,
				rutaData: action.payload.rutaData
			};
		},
		updateEvidenciaByNumSesionRutaKey: (state, action) => {
			const { numeroSesion, rutaKey, evidencia } = action.payload;
			if (state.rutaData && state.rutaKey === rutaKey) {
				const updatedRutaData = {
					...state.rutaData,
					ruta_seguimiento_evidencia: state.rutaData.ruta_seguimiento_evidencia.map((evidenciaItem) =>
						evidenciaItem.numeroSesion === numeroSesion ? { ...evidenciaItem, ...evidencia } : evidenciaItem
					)
				};
				return {
					...state,
					rutaData: updatedRutaData
				};
			}
			return state;
		},
		resetDisplayDesafioCompromisoSeg: () => {
			return initialState;
		}
	}
});

export const {
	setDisplayDesafioCompromisoSeg,
	updateTypeDisplayDesafioCompromisoSeg,
	updateRutaDisplayDesafioCompromisoSeg,
	resetDisplayDesafioCompromisoSeg,
	updateEvidenciaByNumSesionRutaKey
} = displayDesafioCompromisoSegSlice.actions;

export default displayDesafioCompromisoSegSlice.reducer;
